module.exports = __webpack_public_path__ + "static/media/29ADMSPC19.fa653d2f.jpg";